export default __webpack_public_path__ + "static/feature1-232d1c52339b148825a3b24747cb864b.webp";